<button mat-icon-button [disabled]="disabled">
  <span
    i18n-matTooltip="@@FreeTextIconTooltip"
    [matTooltip]="'Full Text'"
    class="material-icons-outlined"
    [matBadge]="linkedFullTextCount"
    [matBadgeDisabled]="disabled"
    (click)="openDialog()"
    >description
  </span>
</button>
